<!--
 * @Author: wjc
 * @Date: 2023-11-13 10:34:56
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2025-12-15 16:11:17
 * @Description: 
-->
<template>
  <MContainer
    :title="parentMenuName"
    desc=""
    bg="/images/service-list-bg.png"
    :row-props="{
      span,
      gutter: $screen.higherThan('xs') ? 20 : null,
    }"
    class="lt-xs:pt-48px"
  >
    <MContent
      :loading="loading"
      :banner-list="carouselList"
      :list="infoList"
      :menu="menuList"
      :breadcrumb="breadcrumbList"
      :page-data="pageData"
      :row-props="{
        gutter: $screen.higherThan('xs') ? 20 : null,
      }"
      @page="onPage"
    ></MContent>
  </MContainer>
</template>

<script setup lang="ts">
  import { getInfoList } from '~/api/activity/info'
  import type { IInfoOptions } from '~/api/activity/info'
  import type { IInfo } from '~/models/activity'
  import { apiBase } from '~/constants'
  // import { getImagesBase64 } from '~/api/options'

  defineOptions({
    name: 'Content',
  })

  const route = useRoute()
  const $screen = useScreen()
  const span = computed(() => $screen.span.value)
  const { menuList, currentMenu, parentMenu } = useMenuList(route.params.id)
  const parentMenuName = computed(() => parentMenu.value.name)
  const loading = ref(false)
  const carouselList = ref<IInfo[]>([])
  const infoList = ref<IInfo[]>([])
  const searchParams = ref<IInfoOptions>({
    pageNum: 1,
    pageSize: 20,
    isPage: true,
  })
  const breadcrumbList = computed(() => {
    return [
      {
        name: '首页',
        to: '/site',
      },
      {
        name: parentMenu.value.name,
        to: `/content/${currentMenu.value.id}`,
      },
      {
        name: currentMenu.value.name,
        to: '',
      },
    ]
  })
  const pageData = ref<PageContent>({
    total: 0,
    pageSize: 0,
    currentPage: 1,
  })
  useHead({
    title: currentMenu.name,
  })

  /** 获取轮播图列表 */
  const getCarouselList = async () => {
    const params = {
      isPage: true,
      classId1: parentMenu.value.id,
      classId2: currentMenu.value.id,
      carousel: 2,
      pageSize: 5,
      pageNum: 1,
    }
    const data = await getInfoList(params)
    if (data && data.data && data.data.list) {
      carouselList.value = data.data.list || []
      if (carouselList.value.length) {
        carouselList.value = data.data.list
          .sort((a, b) => b.top - a.top)
          .map((item) => {
            return {
              ...item,
              img: `${apiBase}/file/download/${item.backgroundImage}`,
            }
          })
        // 用图片id获取图片二进制流，用于base64展示
        // getImagesBase64(ids).then((res) => {
        //   const data = res.data
        //   carouselList.value.forEach((item) => {
        //     const match = data.find((e) => e.fileId === item.backgroundImage)
        //     if (match) {
        //       item.img = 'data:image/png;base64,' + match.base64
        //     }
        //   })
        // })
      }
    }
  }

  const onPage = (v: number) => {
    searchParams.value = {
      ...searchParams.value,
      pageNum: v,
    }
    onGetInfoList()
  }

  /** 获取二级分类列表 */
  const onGetInfoList = () => {
    loading.value = true
    searchParams.value = {
      ...searchParams.value,
      ...{
        classId1: parentMenu.value.id,
        classId2: currentMenu.value.id,
      },
    }
    getInfoList(searchParams.value)
      .then((res) => {
        if (res.data && res.data.list) {
          infoList.value = res.data.list.sort((a, b) => b.top - a.top)
          pageData.value.total = res.data.total
          pageData.value.pageSize = res.data.pageSize
          pageData.value.currentPage = res.data.pageNum
        }
      })
      .finally(() => {
        loading.value = false
      })
  }

  watchEffect(() => {
    if (parentMenu.value.id && currentMenu.value.id) {
      getCarouselList()
      onGetInfoList()
    }
  })
</script>

<style scoped lang="scss"></style>
